import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Welcome from "./Components/Welome";
import Testimonial from "./Components/Testimonial";
import Loader from "./Components/Loader";

const HomePage=()=>{

     useEffect(()=>{
            document.title="Home | Balaji Badminton Academy"
          },[]);

    return(
        <>
        <Header/>
        <Loader/>
        <Welcome/>
        <About/>
        <Testimonial/>
        <Footer/>
        </>
    );
}

export default HomePage;